import React, { ReactElement, useRef } from 'react';
import { AnimationTypes, WaveBgProps } from './wave-bg.types';
import styles from './wave-bg.module.scss';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import cn from 'classnames';

gsap.registerPlugin(useGSAP);

export const WaveBg = (
  {
    animationType = AnimationTypes.WAVE_RIGHT,
    animationComplete,
    className,
    animationStartDirection = 'left'
  }: WaveBgProps): ReactElement => {
  const LEFT_SHAPE = 'm1920,315 C800,775,600,100,0,100 v824 h1920';
  const RIGHT_SHAPE = 'm1920,100 C800,-50,1200,600,0,415 v524 h1920';
  const DURA = 1.5;
  const animationRef = useRef<any>(null);
  let waveRightAnimation: gsap.core.Tween;
  let waveLeftAnimation: gsap.core.Tween;

  const onAnimationComplete = () => {
    if (animationComplete) {
      animationComplete();
    }
  };

  useGSAP(() => {
    waveRightAnimation = gsap.to(animationRef.current, {
      attr: {d: RIGHT_SHAPE},
      duration: DURA,
      ease: 'back.out(.9)',
      paused: true,
      delay: .25,
      onComplete: onAnimationComplete
    });

    waveLeftAnimation = gsap.to(animationRef.current, {
      attr: {d: LEFT_SHAPE},
      duration: DURA,
      ease: 'back.out(.9)',
      paused: true,
      delay: .25,
      onComplete: onAnimationComplete
    });

    animationStartDirection === 'left' ? waveRightAnimation.play() : waveLeftAnimation.play();
  }, [animationType]);

  return (
    <>
      <div className={cn(styles.motionBg, className && className)}>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='100%'
          height='100%'
          viewBox='0 0 1449 824'
          preserveAspectRatio='none'
        >
          <defs>
            <linearGradient
              id='wave-gradient'
              x1='-118'
              y1='329'
              x2='1420'
              y2='-168'
              gradientTransform='translate(0 626) scale(1 -1)'
              gradientUnits='userSpaceOnUse'
            >
              <stop offset='0' stopColor='#20CCDE'/>
              <stop offset='.51' stopColor='#00ACE2'/>
              <stop offset='1' stopColor='#0174C3'/>
            </linearGradient>
          </defs>
          <path ref={animationRef} id='wave' d={animationStartDirection === 'left' ? LEFT_SHAPE : RIGHT_SHAPE} fill='url(#wave-gradient)'/>
        </svg>
      </div>
    </>
  );
};
